import { css } from 'emotion';
import React, { useCallback, useEffect, useRef } from 'react';

import { BREAKPOINT_SMALL } from '../consts/breakpoints';
import { useMobileBackgrounds } from '../hooks/useBackgrounds';
import { CoverPage, MobilePage } from './Page/MobilePage';
import { PageContentMobile } from './PageContent/PageContentMobile';

import { ReactComponent as CloseIcon } from '../assets/close.svg';
import { IBookProps } from '../interfaces/IBookProps';

const mobileWrapper = (isZoomed = false) => css`
  white-space: nowrap;
  padding: ${isZoomed ? '0 20px' : '0'};

  transform-origin: center left;
  transform: scale(${isZoomed ? '0.4' : '0.35'});

  @media (min-width: ${BREAKPOINT_SMALL}) {
    transform: scale(${isZoomed ? '0.45' : '0.4'});
  }
`;

const zoomWrapper = (isZoomed = false) => css`
  position: ${isZoomed ? 'fixed' : 'static'};
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: ${isZoomed ? 'rgba(0, 0, 0, 0.7)' : 'transparent'};
  z-index: 9999;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  align-items: center;

  .exit {
    position: fixed;
    z-index: 9999;
    right: 20px;
    top: 20px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    color: #ffffff;
  }
`;

export const Mobile = (props: IBookProps) => {
  const wrapperRef = useRef<any>();
  const pages = useMobileBackgrounds(props.pages);

  const scrollToElement = () => {
    const page = wrapperRef.current.childNodes[Number(props.page)];
    const transformStyle: any = window.getComputedStyle(wrapperRef.current).transform;
    const regex = /\d+\.\d{0,2}/;
    const transform: any = regex.exec(transformStyle);
    if (wrapperRef) {
      wrapperRef.current.parentNode.scrollLeft = page.offsetLeft * transform[0];
    }
  };

  const addMarginRight = useCallback((page: number) => {
    let margin = '0';

    if (page === 0 || page === 1 || page === pages.length || page % 2 !== 0) {
      margin = '30px';
    }

    return margin;
  }, []);

  useEffect(() => {
    if (props.page === null) {
      return;
    }

    scrollToElement();
  });

  return (
    <div className={zoomWrapper(props.isZoomed)}>
      {props.isZoomed && <CloseIcon className="exit" onClick={() => props.handleZoom()} />}

      <div className={mobileWrapper(props.isZoomed)} ref={wrapperRef}>
        {pages.map((page: any, index: number) => {
          if (page.isCoverFront) {
            return (
              <CoverPage key={index} style={{ marginRight: '30px' }} page={page.page}>
                <PageContentMobile
                  isCoverFront
                  page={page.page}
                  id={`page-${page.page}-content`}
                  backgroundImage={page.background}
                />
              </CoverPage>
            );
          }

          if (page.isCoverBack) {
            return (
              <CoverPage key={index} style={{ marginLeft: '30px' }} page={page.page}>
                <PageContentMobile
                  isCoverBack
                  page={0}
                  id={`page-${page.page}-content`}
                  backgroundImage={page.background}
                />
              </CoverPage>
            );
          }

          return (
            <MobilePage
              key={index}
              page={page.page}
              style={{
                marginRight: addMarginRight(page.page),
              }}
            >
              <PageContentMobile page={page.page} id={`page-${page.page}-content`} backgroundImage={page.background} />
            </MobilePage>
          );
        })}
      </div>
    </div>
  );
};
